<template>
  <a-modal v-model:open="computedShowModal"
           width="480px"
           :closable="false"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
  >
    <div class="modal-content-body">
      <div class="sign-header">
        <div class="modal-title">
          고객에게 전송할 서명 방식 선택
        </div>
        <button
            type="button"
            class="btn-close"
            @click="uiHandler.closeModal"
        >
          <i class="fa-regular fa-x"/>
        </button>
      </div>

      <div class="sign-content d-flex justify-content-center flex-column align-items-center">
        <div class="option-container" :class="selectedMethod === ModuSignMethod.KAKAO ? 'selected' : ''"
             @click="uiHandler.handleMethod(ModuSignMethod.KAKAO)">
          <img src="@/assets/img/signmodal/kakao.png"/>
          <div class="content-container">
            <div class="title">카카오톡으로 전자 서명</div>
            <div class="content">카카오 알림톡으로 계약 상대방에게
              전자 서명을 요청합니다.
            </div>
          </div>
          <div v-if="selectedMethod === ModuSignMethod.KAKAO" class="checked-circle">
            <i class="fa-solid fa-check"/>
          </div>
        </div>
        <div class="option-container" :class="selectedMethod === ModuSignMethod.SECURE_LINK ? 'selected' : ''"
             @click="uiHandler.handleMethod(ModuSignMethod.SECURE_LINK)">
          <img src="@/assets/img/signmodal/device.png"/>
          <div class="content-container">
            <div class="title">대면 서명</div>
            <div class="content">하나의 기기를 통해 계약 상대방과
              직접 만나서 계약을 체결합니다.
            </div>
          </div>
          <div v-if="selectedMethod === ModuSignMethod.SECURE_LINK" class="checked-circle">
            <i class="fa-solid fa-check"/>
          </div>
        </div>
      </div>
    </div>
    <div class="expiration-modal-footer">
      <button class="contract-cancel-btn btn-hover" @click="uiHandler.closeModal">
        취소
      </button>
      <button class="contract-submit-btn btn-hover" @click="uiHandler.emitData">
        확인
      </button>
    </div>
  </a-modal>
</template>
<script>
import {oneBtnDialog} from '@/utils/utils';
import {EmitEvents} from "@/views/ContractManagement/contracts/dentium/EmitEvents";
import {ModuSignMethod} from "@/views/ContractManagement/enums";

export default {
  name: 'SignModal',
  computed: {
    ModuSignMethod() {
      return ModuSignMethod
    },
    computedShowModal() {
      return this.showModal;
    },
  },
  components: {},
  emits: Object.keys({...EmitEvents.SignModal.SelectSignMethod, ...EmitEvents.Common}),
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
  },
  data() {
    return {
      uiHandler: this.ui(),
      selectedMethod: ''

    }
  },

  methods: {
    ui() {
      const handleMethod = (value) => {
        this.selectedMethod = value;
      }
      const emitData = () => {
        if (!this.selectedMethod) {
          oneBtnDialog('서명 방식 미선택', '서명 방식을 선택해주세요.', false);
          return;
        }
        this.$emit(EmitEvents.SignModal.SelectSignMethod, this.selectedMethod)
      }
      return {
        handleMethod,
        emitData,
        closeModal: () => {
          this.$emit(EmitEvents.Common.CloseModal, false);
        }
      }
    },
    /*
      달력 패키지로 생일 선택 시 포맷팅
    */

  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/sign-modal.scss';
</style>
